export const SET_TOP_MENU = 'SET_TOP_MENU';
export const SET_INNER_MENU = 'SET_INNER_MENU';
export const SET_SELECT_PHOTOS = 'SET_SELECT_PHOTOS';
export const SET_SELECT_ALBUMS = 'SET_SELECT_ALBUMS';
export const SET_SHOW_WITH_SELECTED = 'SET_SHOW_WITH_SELECTED';
export const SET_EDITOR_MODE = 'SET_EDITOR_MODE';
export const SET_OPEN_MOBILE_MENU = 'SET_OPEN_MOBILE_MENU';
export const SET_GLOBAL_ERRORS = 'SET_GLOBAL_ERRORS';
export const SET_SITE_OPTIONS = 'SET_SITE_OPTIONS';
export const SET_CHAT_OPENED_WINDOWS = 'SET_CHAT_OPENED_WINDOWS';
export const SET_CHAT_STATE = 'SET_CHAT_STATE';
export const SET_CHAT_WS = 'SET_CHAT_WS';
export const SET_CHAT_MAIN_WINDOW = 'SET_CHAT_MAIN_WINDOW';
export const SET_GRID_MODE = 'SET_GRID_MODE';
export const SET_VISIBILITY = 'SET_VISIBILITY';
export const SET_WEBP_SUPPORT = 'SET_WEBP_SUPPORT';
export const SET_SHOW_POPUP = 'SET_SHOW_POPUP';



export const FETCH_TRANSLATE = 'FETCH_TRANSLATE';
export const FETCH_BLOG_LIST = 'FETCH_BLOG_LIST';
export const FETCH_PHOTO_LIST = 'FETCH_PHOTO_LIST';
export const FETCH_FIGURE_LIST = 'FETCH_FIGURE_LIST';
export const FETCH_ANIME_LIST = 'FETCH_ANIME_LIST';
export const FETCH_CHARACTER_LIST = 'FETCH_CHARACTER_LIST';
export const FETCH_ME = 'FETCH_ME';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const FETCH_REWARDS = 'FETCH_REWARDS';
export const FETCH_ALBUMS_LIST = 'FETCH_ALBUMS_LIST';
export const FETCH_SHELF = 'FETCH_SHELF';
export const FETCH_FIGURE_SHOPS = 'FETCH_FIGURE_SHOPS';
export const FETCH_CURRENCY = 'FETCH_CURRENCY';
export const FETCH_CURRENCY_MARKET = 'FETCH_CURRENCY_MARKET';
export const FETCH_CURRENCY_RATES = 'FETCH_CURRENCY_RATES';
export const FETCH_MINI_CART = 'FETCH_MINI_CART';
export const FETCH_CART = 'FETCH_CART';
export const FETCH_USER_MARKET = 'FETCH_USER_MARKET';
export const FETCH_MARKET_COUNTRIES = 'FETCH_MARKET_COUNTRIES';
export const FETCH_MARKET_SHIP_OPTIONS='FETCH_MARKET_SHIP_OPTIONS';
export const FETCH_MARKET_PAY_OPTIONS='FETCH_MARKET_PAY_OPTIONS';
export const FETCH_MARKET_STORE_ORDERS='FETCH_MARKET_STORE_ORDERS';
export const FETCH_MARKET_ORDER_STATUSES='FETCH_MARKET_ORDER_STATUSES';
export const FETCH_MARKET_USER_ORDERS='FETCH_MARKET_USER_ORDERS';
export const FETCH_MARKET_CONDITIONS='FETCH_MARKET_CONDITIONS';
export const FETCH_MARKET_BOX_CONDITIONS='FETCH_MARKET_BOX_CONDITIONS';
export const FETCH_USERS_LIST = 'FETCH_USERS_LIST';
export const FETCH_GMT_LIST = 'FETCH_GMT_LIST';
export const FETCH_CHAT_NEW_MESSAGES = 'FETCH_CHAT_NEW_MESSAGES';


